"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.palette = void 0;
var RGB_HEX = /^#?(?:([\da-f]{3})[\da-f]?|([\da-f]{6})(?:[\da-f]{2})?)$/i;
var hex2RGB = str => {
  var [, short, long] = String(str).match(RGB_HEX) || [];
  if (long) {
    var value = Number.parseInt(long, 16);
    return [value >> 16, value >> 8 & 0xff, value & 0xff];
  } else if (short) {
    return Array.from(short, s => Number.parseInt(s, 16)).map(n => n << 4 | n);
  }
};

/**
 * Retrieves an RGBA color string from a hex value and transparency
 * level
 */
var getRgba = (hex, transparency) => {
  // If parameters are not defined return original hex
  if (!hex || !transparency) {
    return hex;
  }
  var [r, g, b] = hex2RGB(hex);
  return "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(transparency, ")");
};
var palette = exports.palette = {
  getRgba,
  primary: {
    main: '#262626',
    light: '#393939',
    dark: '',
    contrastText: '#FFFFFF'
  },
  secondary: {
    main: '#F82600',
    light: '#FF3F3F',
    dark: '',
    contrastText: '#FFFFFF'
  },
  background: {
    default: '#F6F6F6',
    paper: '#FFFFFF'
  },
  divider: '#D9D9D9',
  common: {
    white: '#FFFFFF',
    black: '#000000'
  },
  custom: {
    red: {
      main: '#B72F12',
      light: '#E62F09'
    },
    grey: {
      dark: '#333333',
      main: '#C8C8C8',
      light: '#EBEBEB'
    },
    green: {
      main: '#26A69A',
      light: '#00E676',
      faded: '#35BE95'
    },
    blue: {
      main: '#3B88FD',
      light: '#558ac5'
    },
    blackOpaque: 'rgba(0, 0, 0, 0.08)',
    yellow: '#ffff29',
    gainsboro: '#E0E0E0'
  },
  brands: {
    youtube_red: '#FF0000',
    soundcloud_orange: '#FE5000',
    twitter_blue: '#1DA1F2',
    reddit_orange: '#FF5700'
  },
  submissionStatuses: {
    review: '#FFB300',
    approval: '#4DD0E1',
    completed: '#009688',
    flagged: '#FFB74D',
    rejected: '#F44336',
    approved: '#1E88E5'
  }
};